<div class="input-wrapper">
    <input type="text" class="input-class" [placeholder]="('GENERAL.SEARCH' | translate)"
        (input)="onSearchInputChange($event)" [(ngModel)]="searchValue" />
</div>